import { z } from "zod";
export const ControlledAiToolsResultV1Schema = z.object({
    schemaVersion: z.literal("controlled-ai-tools.v1.0"),
    requirementId: z.literal("AI-006"),
    ok: z.boolean(),
    humanContinuationRequired: z.boolean(),
    detail: z.string().optional(),
}).strict();
export function invokeAuthorizedTool(input) {
    const malformed = input.payload.trim().length === 0;
    return ControlledAiToolsResultV1Schema.parse({
        schemaVersion: "controlled-ai-tools.v1.0",
        requirementId: "AI-006",
        ok: !malformed,
        humanContinuationRequired: true,
        detail: malformed ? "malformed_or_low_confidence" : undefined,
    });
}
//# sourceMappingURL=tools.js.map